// extracted by mini-css-extract-plugin
export var fadedContainer = "originalFaded-module--fadedContainer--1mpJn";
export var tint = "originalFaded-module--tint--x63bq";